import { useMsal } from '@azure/msal-react'
import { Box, Group, Loader } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import DashboardMenu from '../../components/dashboard/DashboardMenu'
import { fetchMyOrganization } from '../../data/organization.service'
import { OnboardingOrganization } from '../../models/Onboarding/OnboardingOrganization'

export default function DashboardPage() {
  const [organization, setOrganization] =
    useState<OnboardingOrganization | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const { instance } = useMsal()

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const org = await fetchMyOrganization(instance)
        setOrganization(org)
      } catch (ex) {
        notifications.show({
          title: 'Error loading organization',
          message: 'Unable to load organization information. Please try again.',
          color: 'red',
        })
      } finally {
        setIsLoading(false)
      }
    }

    fetchOrganization()
  }, [instance])

  if (isLoading) {
    return (
      <Group h='100vh' justify='center' align='center'>
        <Loader size='xl' />
      </Group>
    )
  }

  return (
    <div
      style={{
        height: '86vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Left Menu - Hidden on mobile */}
        <Box visibleFrom='sm'>
          <DashboardMenu organization={organization} />
        </Box>

        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
